import classNames from 'classnames';
import { memo } from 'react';
import { BaseNumber } from '@shared/components/base/BaseNumber';

import { Heart } from './Heart';

type Props = {
	isLiked: boolean;
	number?: number;
	size?: number;
	numberStyle?: string;
	color?: string;
	show0?: boolean;
};
export const LikeButton = memo((props: Props) => {
	const { isLiked, number, size, numberStyle, color, show0 = false } = props;
	// 注重首个点赞的动画
	// const likeAnimationStyle = number === 1 && isLiked ? styles.span : styles.ml4;
	return (
		<>
			<Heart isLiked={isLiked} size={size} color={color} />
			<BaseNumber
				num={show0 ? number : number == 0 ? undefined : number}
				className={classNames(numberStyle)}
			/>
		</>
	);
});
